// FAQ.js
import React, { useState } from 'react';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is HR Excel Washing Powder?",
      answer: "HR Excel Washing Powder is a premium quality, high-performance detergent that delivers 3X more stain removal compared to regular powders. It's specially formulated for Indian water conditions, works excellently in hard water, and keeps your clothes bright and fresh."
    },
    {
      question: "How is Hr Bachat Bazar different from other sellers?",
      answer: "At Hr Bachat Bazar, we believe in 'Bachat' (savings) with quality. We source directly from stockists, eliminating middlemen, and pass the savings to you. You get factory-fresh HR Excel Washing Powder at up to 30% lower than market prices, with free home delivery and authentic products guaranteed."
    },
    {
      question: "Do you offer free delivery?",
      answer: "Yes! We offer FREE home delivery on all orders above ₹499. For orders below ₹499, a nominal delivery fee of ₹49 applies. We deliver across India with same-day dispatch in most major cities."
    },
    {
      question: "What is your return/refund policy?",
      answer: "We have a 'Love It or Get Refund' policy. If you're not satisfied with HR Excel Washing Powder, you can return it within 7 days of delivery. No questions asked. We'll process a full refund immediately after receiving the product back."
    },
    {
      question: "How long does delivery take?",
      answer: "Delivery typically takes 3-5 business days for metro cities and 5-7 business days for other locations. You'll receive a tracking link via SMS/Email once your order is dispatched. Same-day dispatch for orders placed before 2 PM."
    },
    {
      question: "Is HR Excel Washing Powder safe for all fabric types?",
      answer: "Absolutely! HR Excel is dermatologically tested and safe for all fabric types including cotton, silk, wool, and synthetic blends. It's gentle on clothes but tough on stains. However, we always recommend checking the care label on delicate garments."
    },
    {
      question: "Do you offer bulk discounts for businesses?",
      answer: "Yes! We provide special wholesale pricing for businesses, hostels, hostels, hotels, and laundry services. Please fill out the Quote form on our website or contact our support team for bulk order pricing and customized deals."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept multiple payment methods for your convenience: Credit/Debit Cards  jazz cash,easy paisa and Cash on Delivery (COD) for orders under Rs 2000. All payments are 100% secure."
    },
    {
      question: "Can I track my order?",
      answer: "Yes! Once your order is confirmed and shipped, you'll receive a unique tracking number via email and SMS. You can use this tracking number on our website's 'Track Order' page or directly on the courier partner's website to monitor your delivery in real-time."
    },
    {
      question: "How do I contact customer support?",
      answer: "You can reach our customer support team via: Email: support@apnabachatbazar.com, Phone: +91-XXXXXXXXXX (Mon-Sat, 10 AM to 7 PM), or Live Chat available on our website. We typically respond within 2-4 hours during business hours."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <div className="inline-block bg-gradient-to-r from-blue-600 to-purple-600 rounded-full p-1 mb-4">
            <div className="bg-white rounded-full px-4 py-1">
              <span className="text-sm font-semibold text-transparent bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text">
                Got Questions?
              </span>
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Find answers to common questions about HR Excel Washing Powder and Hr Bachat Bazar
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mt-6 rounded-full"></div>
        </div>

        {/* Search Bar (Optional) */}
        <div className="mb-8">
          <div className="relative max-w-md mx-auto">
            <input 
              type="text" 
              placeholder="Search your question..." 
              className="w-full px-5 py-3 pl-12 border-2 border-gray-200 rounded-full focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none"
            />
            <svg className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50 transition-all duration-200"
              >
                <span className="text-lg font-semibold text-gray-800 pr-4">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 ml-4">
                  {openIndex === index ? (
                    <svg className="h-6 w-6 text-blue-600 transform rotate-180 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  ) : (
                    <svg className="h-6 w-6 text-gray-500 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </span>
              </button>
              
              <div 
                className={`transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                }`}
              >
                <div className="px-6 pb-5 pt-2 border-t border-gray-100">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Still Have Questions Section */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-8 text-center text-white shadow-xl">
          <div className="max-w-2xl mx-auto">
            <div className="text-5xl mb-4">💬</div>
            <h2 className="text-2xl md:text-3xl font-bold mb-3">
              Still Have Questions?
            </h2>
            <p className="text-blue-100 mb-6">
              Can't find the answer you're looking for? Please reach out to our friendly team.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => window.location.href = '/contact'}
                className="bg-white text-blue-600 px-6 py-3 rounded-full font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-200"
              >
                📧 Contact Support
              </button>
              <button 
                onClick={() => window.location.href = '/quote'}
                className="bg-transparent border-2 border-white px-6 py-3 rounded-full font-semibold hover:bg-white hover:text-blue-600 transition-all duration-200"
              >
                📋 Request a Quote
              </button>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-all">
            <div className="text-2xl mb-2">🚚</div>
            <p className="text-sm font-semibold text-gray-700">Free Delivery</p>
            <p className="text-xs text-gray-500">On orders ₹499+</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-all">
            <div className="text-2xl mb-2">💯</div>
            <p className="text-sm font-semibold text-gray-700">7-Day Returns</p>
            <p className="text-xs text-gray-500">No questions asked</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-all">
            <div className="text-2xl mb-2">⭐</div>
            <p className="text-sm font-semibold text-gray-700">4.9 Rating</p>
            <p className="text-xs text-gray-500">Happy customers</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-all">
            <div className="text-2xl mb-2">🔒</div>
            <p className="text-sm font-semibold text-gray-700">Secure Payment</p>
            <p className="text-xs text-gray-500">100% protected</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;